import ScaleLoader from "react-spinners/ScaleLoader";
import { useEffect } from "react";
import { useGlobalState } from "../../contexts/GlobalContext";

const Loader: React.FC = () => {
  const { globalState } = useGlobalState();
  const { loader, isSaving } = globalState;
  // loaderまたはisSavingがtrueの場合に表示
  const showLoader = loader || isSaving;
  
  useEffect(() => {
    if (showLoader) {
      document.documentElement.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
    }
  }, [showLoader]);

  return showLoader ? (
    <div className="components__loader">
      <div className="components__loader-spinner">
        <ScaleLoader color="#fff" height={30} loading={true} />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Loader;
